import { Component, Input } from '@angular/core';
import Chart from 'chart.js/auto';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-lead-activity-chart',
  imports: [SharedModule],
  templateUrl: './lead-activity-chart.component.html',
  styleUrl: './lead-activity-chart.component.scss'
})
export class LeadActivityChartComponent {
  @Input() data: any;
  @Input() id: string = 'lead-activity-chart';
  @Input() title: string = 'Lead Activity Chart';
  @Input() isDaily: boolean = false;
  @Input() chartType: 'calls' | 'emails' = 'calls';

  selectedMonth: string = '';
  chartInstance: any;

  ngOnChanges() {
    if (this.data) {
      // Set current month if selectedMonth is not already chosen or available in data
      const currentMonth = new Date().toLocaleString('default', { month: 'short' });
      const availableMonths = this.getMonthOptions();

      if (!this.selectedMonth || !availableMonths.includes(this.selectedMonth)) {
        this.selectedMonth = availableMonths.includes(currentMonth) ? currentMonth : availableMonths[0];
      }

      setTimeout(() => this.renderChart(), 100);
    }
  }

  renderChart() {
    if (!this.data) return;

    const ctx: any = document.getElementById("canvas__" + this.id);
    if (!ctx) return;

    const context = ctx.getContext('2d');

    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }

    let labels: string[] = [];
    let values: number[] = [];

    if (this.isDaily) {
      const monthData = this.data.daily[this.selectedMonth] || {};
      console.log('Month Data:', monthData);
      const monthIndex = new Date(`${this.selectedMonth} 1, 2025`).getMonth();
      const daysInMonth = new Date(2025, monthIndex + 1, 0).getDate();

      labels = Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString().padStart(2, '0'));
      values = labels.map(day => monthData[day] ?? 0);
    } else {
      labels = Object.keys(this.data.yearly);
      values = Object.values(this.data.yearly);
    }

    this.chartInstance = new Chart(context, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          data: values,
          pointRadius: 3,
          pointHoverRadius: 5,
          borderWidth: 3,
          borderColor: '#F0950C',
          backgroundColor: 'rgba(240, 149, 12, 0.1)',
          fill: false,
        }]
      },
      options: {
        animation: {
          duration: 1,
          onComplete: function ({ chart }) {
            const ctx = chart.ctx;

            chart.config.data.datasets.forEach(function (dataset, i) {
              const meta = chart.getDatasetMeta(i);

              meta.data.forEach(function (bar, index) {
                const data: any = dataset.data[index];
                console.log(data)

                // ctx.fillText(data, bar.x, bar.y - 5);
              });
            });
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        },
        scales: {
          y: {
            grid: { display: true }
          },
          x: {
            grid: { display: true }
          }
        }

      },
    });
  }

  onMonthChange(event: any) {
    this.selectedMonth = event.target.value;
    this.renderChart();
  }

  getMonthOptions(): string[] {
    return Object.keys(this.data?.daily || {});
  }
}
